import { storyblokEditable } from '@storyblok/react';
import { Box } from '@terminal/design-system';
import type { SpacerStoryblok, Storyblok } from '../types';
import { selectResponsiveStyle } from '@helpers/storyblok.utils';

export function Spacer({ blok }: Storyblok<SpacerStoryblok>) {
  return <Box height={selectResponsiveStyle(blok.height)} {...storyblokEditable(blok)} />;
}
